/*******************************************************************************
WATCH ITEMS
Watch the items being filtered and react to any input changes.
*******************************************************************************/

import getFilterSettings from './get-filter-settings';
import updateFilterCounts from './update-filter-counts';

export default function watchItems() {
    const { items } = getFilterSettings();

    // Set up an event handler to update the tab counts whenever a change is made to an input within an item
    $(items).on('change', ':input', () => { updateFilterCounts(); });
}
